const CARD_STATUSES = new Set(['working', 'filled', 'failed', 'closed'])

function hasValue(value) {
  if (value == null) return false
  if (typeof value === 'number') return Number.isFinite(value) && value !== 0
  if (typeof value === 'string') return value.trim().length > 0
  if (Array.isArray(value)) return value.length > 0
  return true
}

export function hasSetupDetails(project) {
  if (!project) return false

  const status = String(project.setup_status || '').trim().toLowerCase()
  if (CARD_STATUSES.has(status)) return true

  return [
    project.setup_pattern,
    project.trigger_price,
    project.pattern_failure_price,
    project.sell_target_price,
    project.recommended_size_pct,
    project.account_sizing,
    project.schwab_order_ids,
  ].some(hasValue)
}
